import { render, staticRenderFns } from "./TicketCreate.vue?vue&type=template&id=a31ef360&scoped=true"
import script from "./TicketCreate.vue?vue&type=script&lang=js"
export * from "./TicketCreate.vue?vue&type=script&lang=js"
import style0 from "./TicketCreate.vue?vue&type=style&index=0&id=a31ef360&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a31ef360",
  null
  
)

export default component.exports